import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import IconButton from '@material-ui/core/IconButton';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ListItem from '@material-ui/core/ListItem';
import List from '@material-ui/core/List';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import Divider from '@material-ui/core/Divider';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Avatar from '@material-ui/core/Avatar';
import { red } from '@material-ui/core/colors';
import Paper from '@material-ui/core/Paper';
import { fetchDefault } from '../Utils.js';

const useStyles = makeStyles(theme => ({
    appBar: {
        position: 'relative',
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    avatar: {
        backgroundColor: red[500],
    },
    paper: {
        width: 100,
        marginTop: 1,
        overflowX: 'auto',
    },
    seatInfoButton: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        marginTop: theme.spacing(2),
        width: 100,
    },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function SeatInfoDialog(props) {
    const classes = useStyles();

    const [open, setOpen] = React.useState(false);
    const [seatList, setSeatList] = React.useState([]);

    const handleClickOpen = () => {
        setOpen(true);

        //전체자리
        fetchDefault('/Payment/GetAllSeatList?time=' + props.time,
            (data) => {
                setSeatList([data][0]);
            }
        );
        
    };
    const handleClose = () => {
        setOpen(false);
    };

    const selectSeat = (tableId) => {
        setOpen(false);
        props.onTableChanged(tableId);
    };

    return (
        <div style={{ display:'inline-block'}} >
            <Button className={classes.seatInfoButton} variant="outlined" color="primary" onClick={handleClickOpen}>
                <Typography variant="body2">
                    전체자리 확인하기
                </Typography>
            </Button>

            <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}>
                <AppBar className={classes.appBar}>
                    <Toolbar>
                        <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
                            <CloseIcon />
                        </IconButton>
                        <Typography variant="h6" className={classes.title}>
                            전체자리 확인하기
                        </Typography>
                        <Button color="inherit" onClick={handleClose}>
                            뒤로가기
                        </Button>
                    </Toolbar>
                </AppBar>
                <Paper className={classes.paper}>
                    <img alt="loading..." src={require('../../images/seats_v1.0.png')} style={{ width: 600 }} />
                </Paper>
                <List style={{ marginTop: 600 }}>

                    {seatList.map(s => (
                        <ListItem button key={s.tableId}>
                            <ListItemText primary={s.explain} />
                            <ListItemSecondaryAction>
                                <Button variant="outlined" color="primary" onClick={() => selectSeat(s.tableId)}>
                                    선택
                                </Button>
                            </ListItemSecondaryAction>
                        </ListItem>
                    ))}
                </List>
            </Dialog>
        </div>
    );

}



// WEBPACK FOOTER //
// ./src/components/seat/SeatInfoDialog.js